import { render, staticRenderFns } from "./TermsWriteComponent.vue?vue&type=template&id=94d4de9a&scoped=true&"
import script from "./TermsWriteComponent.vue?vue&type=script&lang=js&"
export * from "./TermsWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d4de9a",
  null
  
)

export default component.exports